import React from 'react';
import { motion } from 'framer-motion';
import { HardHatIcon, LeafIcon, RulerIcon, SproutIcon, ZapIcon } from 'lucide-react';
const roles = [{
  icon: RulerIcon,
  title: 'Arquitectura y diseño',
  description: 'Concepto, proyecto y definición espacial.'
}, {
  icon: HardHatIcon,
  title: 'Dirección de obra',
  description: 'Coordinación diaria y control de ejecución.'
}, {
  icon: SproutIcon,
  title: 'Instalaciones sanitarias',
  description: 'Planificación precisa de cada instalación.'
}, {
  icon: ZapIcon,
  title: 'Instalaciones eléctricas',
  description: 'Confort, funcionalidad y calidad técnica.'
}, {
  icon: LeafIcon,
  title: 'Paisajismo y terminaciones',
  description: 'Materia, vegetación y detalle final.'
}];
export function Team() {
  return <section id="equipo" className="bg-[#F7F4EF] px-5 py-24 md:px-10 lg:py-32" data-id="element-181">
      <div className="mx-auto max-w-[1440px]" data-id="element-182">
        <div className="grid gap-12 lg:grid-cols-[1.05fr_.95fr] lg:items-center lg:gap-20" data-id="element-183">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.25
        }} transition={{
          duration: 0.55
        }} className="relative" data-id="element-184">
            <img src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?auto=format&fit=crop&w=1400&q=85" alt="Equipo profesional reunido en una mesa de trabajo" className="h-[390px] w-full object-cover sm:h-[500px] lg:h-[620px]" data-id="element-185" />
            <div className="absolute -bottom-4 left-5 border border-[#e4d8ca] bg-white px-5 py-4 text-[10px] font-bold uppercase tracking-[.18em] text-[#655f57] md:-left-5" data-id="element-186">
              Trabajo coordinado, resultado preciso
            </div>
          </motion.div>

          <div data-id="element-187">
            <p className="text-[11px] font-bold uppercase tracking-[.2em] text-[#C4724A]" data-id="element-188">
              Nuestro equipo
            </p>
            <h2 className="font-editorial mt-5 max-w-xl text-4xl leading-tight md:text-5xl" data-id="element-189">
              Un equipo para llevar cada idea a la realidad
            </h2>
            <p className="mt-6 max-w-xl text-sm leading-7 text-[#655f57]" data-id="element-190">
              Cada proyecto reúne especialistas que comparten una misma forma de
              trabajar: escucha, precisión y compromiso con cada detalle. La
              coordinación interdisciplinaria nos permite cuidar el proceso
              desde el primer trazo hasta la obra terminada.
            </p>

            <div className="mt-10 grid border-l border-t border-[#ded6ca] sm:grid-cols-2" data-id="element-191">
              {roles.map(({
              icon: Icon,
              title,
              description
            }, index) => <motion.article key={title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.15
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} className="group relative min-h-[150px] border-b border-r border-[#ded6ca] bg-white/45 p-5" data-id="element-192">
                  <div className="absolute left-0 top-0 h-full w-0.5 bg-[#C4724A] opacity-0 transition-opacity duration-200 group-hover:opacity-100" data-id="element-193" />
                  <Icon size={20} strokeWidth={1.35} className="text-[#C4724A]" data-id="element-194" />
                  <h3 className="mt-5 text-sm font-bold" data-id="element-195">{title}</h3>
                  <p className="mt-2 text-xs leading-5 text-[#716a61]" data-id="element-196">
                    {description}
                  </p>
                </motion.article>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}